<template>
  <div>
    <step1 v-if="step==1" @transferTep="goToNext"></step1>
    <step2 v-if="step==2"></step2>
  </div>
</template>
<script>
  import step1 from "../components/forget_password/step1"
  import step2 from "../components/forget_password/step2"
  export default {
    name : 'forgetPassword',
    data () {
      return {
        step : 1
      }
    },
    components : {
      "step1" : step1,
      "step2" : step2
    },
    methods : {
      goToNext(msg){
        this.step=msg;
      }
    }
  }
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/view/forgetPassword.vue